import { render, staticRenderFns } from "./m-section-usp.vue?vue&type=template&id=41b751a2&scoped=true&"
import script from "./m-section-usp.vue?vue&type=script&lang=js&"
export * from "./m-section-usp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b751a2",
  null
  
)

export default component.exports